<template>
  <div class="w-full">
    <SmartTitle
      weight="medium"
      class="main-title mb-4"
      style="margin-top: -0.5rem"
    >
      Business Plan
    </SmartTitle>
    <div class="w-full flex justify-between mb-4">
      <SmartSearch class="main-search">
        <v-text-field
          v-model="search"
          @keyup="searchBusinessPlan"
          append-icon="search"
          placeholder="Pesquisar..."
          single-line
          hide-details
          class="search"
        />
      </SmartSearch>
      <div class="flex justify-end">
        <SmartButton
          :loading="isLoadingDownload"
          @click="modelDownload"
          class="mr-3"
          quaternary
        >
          <SmartIcon name="download" class="mr-2" :size="1"/>
          Baixar Modelo
        </SmartButton>
        <input
          style="display: none"
          type="file"
          :key="fileUploadKey"
          id="fileInput"
          @change="importCsv"
          class="fileInput"
        />
        <label
          v-if="!isLoadingImport"
          class="label-import cursor-pointer smart-button--default rounded h-5 px-3 text-center user-select-none mr-3"
          for="fileInput"
          style="background-color: #FFFFFF; color: #77BD4F; border: 1px solid #77BD4F; display: flex; align-items: center;width:180px">
          <SmartIcon name="upload" :size="1"/>&nbsp;&nbsp;
          <p>Importar Arquivo</p>
        </label>
        <SmartButton v-else :loading="true" class="label-import smart-button--default rounded h-5 px-3 text-center user-select-none mr-3" tertiary style="border: 1px solid #77BD4F; width:180px">Importar Arquivo</SmartButton>
        <SmartButton @click="newPlan">
          Novo Business Plan
        </SmartButton>
      </div>
    </div>
    <div class="main-section">
      <div>
        <div v-if="!isLoadingActive">
          <SmartTitle  weight="medium">
            Lista de ativos
          </SmartTitle>
          <VDataTable
            :headers="headerActive"
            :items="listActiveGetter"
            no-data-text="Não há dados a serem exibidos"
            hide-actions
            class="my-4"
          >
            <template slot="items" slot-scope="props">

              <td
                class="no-wrap"
                style="width: 50%">
                <SmartP class="text-overflow-hidden text-black text-overflow-ellipsis">{{ props.item.place_name }}</SmartP>
              </td>
              <td>
                {{ formatDate(props.item.created_at) }}
              </td>
              <td class="view-icon">
                <label
                  @click="planEdit(props.item.place_id)"
                  class="ml-3 cursor-pointer"
                >
                  <SmartIcon
                    :size="2"
                    name="edit"
                    class="mr-1-2"
                  />
                </label>
              </td>
              <td class="view-icon">
                <label
                  class="cursor-pointer"
                  @click="planDisable(props.item.id)"
                >
                  <SmartIcon
                    :size="2"
                    name="check_block"
                    class="ml-4"
                  />
                </label>
              </td>
            </template>
          </VDataTable>
        </div>
        <div v-else>
          <SmartSkeletonLoading
            :items="10"
            :height="3"
          />
        </div>
        <div class="text-center mb-5">
          <VPagination
            v-if="lengthActive > 1"
            v-model="pageActive"
            :length="lengthActive"
            @input="changeActivationPage(pageActive)"
            :value="paginationActiveGetter.current_page"
            :total-visible="7"
            circle
            class="mt-4"
          />
        </div>
      </div>
      <div>
        <div v-if="!isLoadingDisabled">
          <SmartTitle weight="medium">
            Lista de inativos
          </SmartTitle>
          <VDataTable
            :headers="headerDisabled"
            :items="listDisabledGetter"
            no-data-text="Não há dados a serem exibidos"
            hide-actions
            class="my-4"
          >
            <template slot="items" slot-scope="props">

              <td
                class="no-wrap"
                style="width: 50%"
              >
                <SmartP
                  class="text-overflow-hidden text-black text-overflow-ellipsis">
                  {{ props.item.place_name }}
                </SmartP>
              </td>
              <td>
                {{ formatDate(props.item.created_at) }}
              </td>
              <td class="view-icon">
                <label
                  @click="planEdit(props.item.place_id)"
                  class="ml-3 cursor-pointer"
                >
                  <SmartIcon
                    :size="2"
                    name="edit"
                  />
                </label>
              </td>
              <td class="view-icon">
                <label
                  class="cursor-pointer"
                  @click="planActive(props.item.id)"
                >
                  <SmartIcon
                    :size="2"
                    name="check_ok"
                    class="ml-3"
                  />
                </label>
              </td>
            </template>
          </VDataTable>
        </div>
        <div v-else>
          <SmartSkeletonLoading
            :items="10"
            :height="3"
          />
        </div>
        <div class="text-center mb-5">
          <VPagination
            v-if="lengthDisabled > 1"
            v-model="pageDisabled"
            @input="changeDisabledPage(pageDisabled)"
            :length="lengthDisabled"
            :value="currentPageDisabled"
            :total-visible="7"
            circle
            class="mt-4"
          />
        </div>
        <SmartModal
          v-if="modal"
          v-bind="modal"
          @close="modal = null"
        >
          {{ modal.text }}
        </SmartModal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { formatBRDate } from 'utils/date';
import { downloadCsvFile } from 'utils/blob';
import moment from 'moment';

export default {
  components: {
    SmartSearch: () => import('../../../../packages/SmartSearch/index')
  },
  data() {
    return {
      headerActive: [
        { text: 'PDV', value: 'place', sortable: false },
        { text: 'Criado em', value: 'date', sortable: false },
        { text: 'Editar', value: 'edit', sortable: false },
        { text: 'Desativar', value: 'disable', sortable: false }
      ],
      headerDisabled: [
        { text: 'PDV', value: 'place', sortable: false },
        { text: 'Criado em', value: 'date', sortable: false },
        { text: 'Editar', value: 'edit', sortable: false },
        { text: 'Ativar', value: 'disable', sortable: false }
      ],
      pageActive: 1,
      pageDisabled: 1,
      modal: null,
      isLoadingActive: false,
      isLoadingDisabled: false,
      isLoadingImport: false,
      isLoadingDownload: false,
      fileUploadKey: 0,
      search: ''
    };
  },
  computed: {
    ...mapGetters({
      listActiveGetter: 'businessPlan/listActiveGetter',
      listDisabledGetter: 'businessPlan/listDisabledGetter',
      paginationActiveGetter: 'businessPlan/paginationActiveGetter',
      paginationDisabledGetter: 'businessPlan/paginationDisabledGetter'
    }),
    lengthActive() {
      return this.paginationActiveGetter && this.paginationActiveGetter.last_page;
    },
    lengthDisabled() {
      return this.paginationDisabledGetter && this.paginationDisabledGetter.last_page;
    },
    currentPageActive() {
      return this.paginationActiveGetter && this.paginationActiveGetter.current_page;
    },
    currentPageDisabled() {
      return this.paginationDisabledGetter && this.paginationDisabledGetter.current_page;
    }
  },
  methods: {
    ...mapActions({
      fetchListActive: 'businessPlan/fetchListActive',
      fetchListNonActive: 'businessPlan/fetchListNonActive',
      disablePlan: 'businessPlan/disablePlan',
      activePlan: 'businessPlan/activePlan',
      downloadModelBusinessPlan: 'businessPlan/downloadModelBusinessPlan',
      importCsvFile: 'businessPlan/sendCsvFile'
    }),

    disableKeysWithLessThanThreeCharacters(keyCode) {
      return [37, 38, 39, 40].includes(keyCode);
    },
    async searchBusinessPlan(e) {
      if (!this.search) {
        if (!this.disableKeysWithLessThanThreeCharacters(e.keyCode)) {
          this.isLoadingActive = true;
          this.isLoadingDisabled = true;
          await this.fetchListActive();
          await this.fetchListNonActive();
        }
      } else if (this.disableKeysWithLessThanThreeCharacters(e.keyCode)) {
        return;
      } else {
        this.isLoadingActive = true;
        this.isLoadingDisabled = true;
        await this.fetchListActive({ page: 1, search: this.search });
        await this.fetchListNonActive({ page: 1, search: this.search });
      }
      this.isLoadingActive = false;
      this.isLoadingDisabled = false;
    },

    async changeActivationPage(page) {
      this.isLoadingActive = true;
      await this.fetchListActive({ page: page, search: '' });
      this.isLoadingActive = false;
    },
    async changeDisabledPage(page) {
      this.isLoadingDisabled = true;
      await this.fetchListNonActive(({ page: page, search: '' }));
      this.isLoadingDisabled = false;
    },
    showModal(params) {
      this.modal = {
        type: params.type,
        title: params.title,
        icon: params.icon,
        buttonText: params.buttonText,
        secondButton: params.secondButton,
        text: params.text
      };
    },
    newPlan() {
      this.$router.push({ name: 'BusinessPlanAdd' });
    },
    planEdit(id) {
      this.$router.push({ name: 'BusinessPlanEdit', params: { id } });
    },
    planDisable(id) {
      this.isLoadingDisabled = true;
      this.isLoadingActive = true;
      this.pageActive -= Number(this.listActiveGetter.length === 1);
      this.disablePlan(id)
        .then(async () => {
          const message = 'Business Plan desativado com sucesso!';
          this.isLoadingDisabled = true;
          await this.fetchAllList();
          this.isLoadingDisabled = false;
          this.showModal({
            type: 'success',
            title: 'Ok! Tudo certo.',
            icon: 'accepted',
            buttonText: 'Ok',
            text: message
          });
        })
        .finally(() => {
          this.isLoadingDisabled = false;
          this.isLoadingActive = false;
        });
    },
    planActive(id) {
      this.pageActive -= Number(this.listActiveGetter.length === 1);
      this.activePlan(id)
        .then(async () => {
          const message = 'Business Plan ativado com sucesso!';
          this.isLoadingActive = true;
          await this.fetchAllList();
          this.isLoadingActive = false;
          this.showModal({
            type: 'success',
            title: 'Ok! Tudo certo.',
            icon: 'accepted',
            buttonText: 'Ok',
            text: message
          });
        });
    },
    fetchAllList() {
      Promise.all([this.fetchListActive(), this.fetchListNonActive()]);
    },
    formatDate(value) {
      return formatBRDate(value);
    },
    modelDownload() {
      this.isLoadingDownload = true;
      const currentDate = moment().format('Do_MM_YYYY, h:mm:ss a');
      this.downloadModelBusinessPlan()
        .then(({ data }) => {
          downloadCsvFile({ filename: `business_plan_${currentDate}`, file: data });
        }).finally(() => {
          this.isLoadingDownload = false;
        });
    },
    importCsv(event) {
      this.isLoadingImport = true;
      const file = event.target.files[0];
      const formData = new FormData();
      formData.set('file', file, file.name);
      this.importCsvFile(formData)
        .then(() => {
          this.modal = {
            type: 'success',
            title: 'Ok, tudo certo!',
            icon: 'accepted',
            buttonText: 'Ok',
            text: 'O arquivo foi importado.'
          };
        })
        .catch((error) => {
          this.modal = {
            type: 'warning',
            title: 'Arquivo não importado.',
            icon: 'warning',
            buttonText: 'Ok',
            text: error.data.message
          };
        })
        .finally(() => {
          this.isLoadingImport = false;
          this.fetchListActive();
          this.fetchListNonActive();
        });
      this.fileUploadKey++;
    }
  },
  async mounted() {
    this.isLoadingActive = true;
    this.isLoadingDisabled = true;
    await this.fetchListActive();
    this.isLoadingActive = false;
    await this.fetchListNonActive();
    this.isLoadingDisabled = false;
  }
};
</script>

<style lang="scss">
  .main-search div.v-input__append-inner {
    background: none!important;
  }
</style>
